<h5><fa-icon [icon]="['fas','truck-moving']"></fa-icon>  {{"TRANS_REMOTE_BUY.TRANS_BILLING_INFO" | translate}}</h5>
<form [formGroup]="billingForm">
	<div class="row">
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">{{"TRANS_REMOTE_BUY.TRANS_STREET_ADDRESS" | translate}}</div>
			<div>
				<input type="text" class="form-control" formControlName="street" [readOnly]="readonlyState['street']">
			</div>
			<div class="error text-danger" *ngIf="billingForm.controls.street.invalid">
				{{"TRANS_REMOTE_BUY.TRANS_STREET_ADDRESS_ERROR" | translate}}
			</div>
		</div>
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">{{"TRANS_REMOTE_BUY.TRANS_COUNTRY" | translate}}</div>
			<div style="height: 51px;margin-top: -17px;">
				<ng-select [items]="countries$ | async" ngDefaultControl bindLabel="name" bindValue="alpha2"
						    formControlName="country">
				</ng-select>
				<div style="margin-top: -18px;" class="error text-danger" *ngIf="billingForm.controls.country.invalid">
					{{"TRANS_REMOTE_BUY.TRANS_COUNTRY_SELECT" | translate}}
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-md-6">
			<div class="col-form-label">{{"TRANS_REMOTE_BUY.TRANS_POSTAL" | translate}}</div>
			<div>
				<input type="text" class="form-control" formControlName="postcode" [readOnly]="readonlyState['postcode']">
				<div class="error text-danger" *ngIf="billingForm.controls.postcode.invalid">
					{{"TRANS_REMOTE_BUY.TRANS_POSTAL_ERROR" | translate}}
				</div>
			</div>
		</div>
		<div class="col-md-6">
			<div class="col-form-label">{{"TRANS_REMOTE_BUY.TRANS_REGION" | translate}}</div>
			<div>
				<input type="text" class="form-control" formControlName="region" [readOnly]="readonlyState['region']">
				<div class="error text-danger" *ngIf="billingForm.controls.region.invalid">
					{{"TRANS_REMOTE_BUY.TRANS_REGION_ERROR" | translate}}
				</div>
			</div>
		</div>
	</div>
</form>